import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full text-xs sm:text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#17c671]/40 focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#17c671] text-white shadow-sm hover:bg-[#14a85d]",
        destructive:
          "bg-red-600 text-white shadow-sm hover:bg-red-700",
        outline:
          "border border-gray-300 bg-white text-[#212529] shadow-sm hover:bg-gray-100",
        secondary:
          "bg-[#eef2f6] text-[#212529] shadow-sm hover:bg-[#e3e8ee]",
        ghost: "text-[#212529] hover:bg-gray-100",
        link: "text-[#17c671] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-8 px-3 py-1.5 sm:h-9 sm:px-4 sm:py-2",
        sm: "h-7 px-2.5 text-[11px] sm:h-8 sm:px-3 sm:text-xs",
        lg: "h-9 px-6 sm:h-10 sm:px-8",
        icon: "h-8 w-8 sm:h-9 sm:w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
